var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAntenna4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 488 488",
    style: {
      enableBackground: "new 0 0 488 488"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82CC00"
    },
    d: "M40,324.8c-19.2,0-40,3.2-40,26.4v84c0,23.2,20.8,26.4,40,26.4s40-3.2,40-26.4v-84 C80,328,59.2,324.8,40,324.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61C105"
    },
    d: "M42.4,460.8c19.2,0,37.6-3.2,37.6-26.4v-83.2c0-23.2-19.2-26.4-38.4-26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82CC00"
    },
    d: "M180,225.6c-19.2,0-36,3.2-36,26.4v183.2c0,23.2,16.8,26.4,36,26.4s36-3.2,36-26.4V252 C216,228.8,199.2,225.6,180,225.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61C105"
    },
    d: "M178.4,460.8c19.2,0,37.6-3.2,37.6-26.4V252c0-23.2-19.2-26.4-38.4-26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82CC00"
    },
    d: "M316,126.4c-19.2,0-36,3.2-36,26.4v282.4c0,23.2,16.8,26.4,36,26.4s36-3.2,36-26.4V152.8 C352,129.6,335.2,126.4,316,126.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61C105"
    },
    d: "M314.4,460.8c19.2,0,37.6-3.2,37.6-26.4V152.8c0-23.2-19.2-26.4-38.4-26.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82CC00"
    },
    d: "M452,27.2c-19.2,0-36,3.2-36,26.4v381.6c0,23.2,16.8,26.4,36,26.4s36-3.2,36-26.4V52.8 C488,29.6,471.2,27.2,452,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#61C105"
    },
    d: "M450.4,460.8c19.2,0,37.6-3.2,37.6-26.4V52.8c0-23.2-19.2-26.4-38.4-26.4"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntenna4);
export default __webpack_public_path__ + "static/media/antenna4.f162a35aa3ada4cc556685c3938e9964.svg";
export { ForwardRef as ReactComponent };